/**
 * Truncate a transaction or address hash
 */
const convertToSixDecimal = (amount: string) => {
    return (Math.trunc((Number(amount) * 1000000)) / 1000000).toString()
}

export default convertToSixDecimal
